<svelte:options customElement={{
  tag: 'anchor-link',
  shadow: 'none',
  props: {
    items: { reflect: true, type: 'String' },
    layout: { reflect: true, type: 'String' }
  }
}} />

<script>
  import SvgIcon from './SvgIcon.svelte';

  /**
   * navi2：ページ内リンク（アンカーリンク）
   * パーツライブラリ準拠の mod-anchorLink 構造
   * @prop {string} items - JSON形式 '[{"href":"#section1","label":"セクション1"}]'
   * @prop {string} layout - 'center' | 'left' | 'stack'
   */
  export let items = '[]';
  export let layout = 'center';

  let parsedItems = [];

  $: {
    try {
      parsedItems = typeof items === 'string' ? JSON.parse(items) : (Array.isArray(items) ? items : []);
    } catch (e) {
      console.warn('AnchorLink: Invalid items JSON', e);
      parsedItems = [];
    }
  }

  $: layoutClass = layout === 'stack' ? '_stack' : layout === 'left' ? '_left' : '';
</script>

<ul class="mod-anchorLink {layoutClass}">
  {#each parsedItems as item}
    <li>
      <a href={item.href}>
        <span class="_text">{item.label}</span>
        <SvgIcon name="arrow_bottom" size="md" />
      </a>
    </li>
  {/each}
  <slot></slot>
</ul>
